import axios from 'axios';
import Vue from 'vue';
// import { errorHandler } from "../exports/error_management";

// import { buildQuery } from '../exports/queryStringBuilder'
// const getHash = () =>
//     Date.now().toString(36) + Math.random().toString(36).substring(2)

const state = {
    documents: [],
    pagination: null,
    docs : [],
}



const mutations = {

    cleardocuments(state) {
        state.documents = []; 
    },

    SET_DOCUMENTS(state, schedules) {
        state.documents = schedules;
    },
    SET_DOCUMENTS_NOT_PAGINATED(state, schedules) {
        state.documentsNotPaginated = schedules;
    },
    ADD_DOCUMENT(state, schedule) {
        state.documents.push(schedule);
    },
    UPDATE_DOCUMENT(state, updatedSchedule) {
        const index = state.documents.findIndex(schedule => schedule.id === updatedSchedule.id);
        if (index !== -1) {
            Vue.set(state.documents, index, updatedSchedule);
        }
    },
    DELETE_DOCUMENT(state, scheduleId) {
        state.documents = state.documents.filter(schedule => schedule.id !== scheduleId);
    },
    SET_PAGINATION(state, pag) {
        state.pagination = pag;
      },
      SET_DOC_LIST(state,docs){
        state.docs = docs;
      }

}

const actions = {
   


   async fetchdocumentsAll({ commit },params){
    let { activityTypeId } = params || {}
    let { order_id} =params || {}
    const response = await axios.get(`ordertype/documents?activity_type_id=${activityTypeId}&order_id=${order_id}&change_link=yes`);
        
    // let value = response.data.success.data;
    
    commit('SET_DOC_LIST', response.data.success.data);
  },
  
  async fetchdocumentsAllCustomer({ commit },params){
    let { activityTypeId } = params || {}
    let { order_id} =params || {}
    const response = await axios.get(`ordertype/customer-documents?activity_type_id=${activityTypeId}`);
        
    // let value = response.data.success.data;
    
    commit('SET_DOC_LIST', response.data.success.data);
  },
    async fetchdocuments({ commit },params) {
        let { activityTypeId, page: pg } = params || {}
       
        pg = pg || 0
        activityTypeId = activityTypeId || ""
   
        // let crm = false
        const response = await axios.get(`ordertype/documents?page=${pg}&activity_type_id=${activityTypeId}`);
        
        let value = response.data.success.data;
        if(pg > 0) {
            const {
                data: _document = [],
                current_page: page,
                per_page: pageSize = 15,
                total = 0,
            } = value || {};

            
            // console.log('page size------',pageSize);
            // console.log('total------',total);
            // console.log('_schedule--------',_document);
            commit("SET_PAGINATION", {
                page,
                pageSize,
                total,
            });
            commit('SET_DOCUMENTS',_document);
        } else {
            commit('SET_DOCUMENTS_NOT_PAGINATED',[]);
            commit('SET_DOCUMENTS_NOT_PAGINATED',value);
        }
    },

    async addDocument({ commit },{ schedule, activityTypeId }) {
        
        const response = await axios.post(`ordertype/${activityTypeId}/documents`, schedule);
        commit('ADD_DOCUMENT', response.data.success.data);
    },
    async updateDocument({ commit }, { schedule, activityTypeId }) {
        
        const response = await axios.put(`ordertype/${activityTypeId}/documents/${schedule.id}`, schedule);
        commit('UPDATE_DOCUMENT', response.data.success.data);
    },
    async deleteDocument({ commit }, { schedule, activityTypeId }) {
       
        await axios.delete(`ordertype/${activityTypeId}/documents/${schedule}`);
        commit('DELETE_DOCUMENT', schedule);
    },

    async convertToPdf(_,{link}){
        console.log('link----',link);
       let result = await axios.post(`ordertype/generate-pdf`,{link:link},{
        responseType: 'blob'
    });
        return result;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
  
}
